module.exports = __webpack_public_path__ + "html/top-layout_9b95e61e5c017537657e059804636bd9.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/top-layout.html
// module id = 23em
// module chunks = 154